import {combineReducers} from 'redux';
import sbl_login_response from './sblLoginReducer';
import * as types from '../actions/actionTypes';

const appReducer = combineReducers({
    sbl_login_response
});

const rootReducer = (state, action) => {
    // if (action.type === types.LOG_OUT) {
    //     state = undefined;
    // }

    return appReducer(state, action);
};

export default rootReducer; 


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js